'use client'

import { useMemo } from 'react'
import { DefaultRoleSyncStrategy } from '@/services/shared/auth/roleSyncStrategy'
import { useTrustedIdentityScopes } from '@/hooks/useTrustedIdentityScopes'

export function useIsSuperAdmin(): {
  isSuperAdmin: boolean
  isSuperAdminCheckReady: boolean
} {
  const { scopes, isReady } = useTrustedIdentityScopes({
    errorMessage: 'Error checking super-admin status:',
  })

  const isSuperAdmin = useMemo(() => {
    // Fail closed: no scopes (cache miss or fetch error) → not a super-admin.
    if (scopes === null) return false
    return new DefaultRoleSyncStrategy().isAshAdmin(scopes)
  }, [scopes])

  return { isSuperAdmin, isSuperAdminCheckReady: isReady }
}
